package com.essntl.features.service.ui.addeditservice

import core.validation.Form
import core.validation.field.StringField
import core.validation.validator.NonEmptyValidator

class AddEditServiceValidation {
    val addEditServiceForm = AddEditServiceForm()
}

class AddEditServiceForm : Form() {
    val title =
        StringField(NonEmptyValidator)

    val category =
        StringField(NonEmptyValidator)

    override val fields = listOf(title, category)
}
